export function AboutPage() {
  return (
    <section className="section">
      <div className="narrow-container container">

        <div className="panel about-panel">
          <div className="about-header">
            <div className="about-header-text">
              <h2>Simone Cammarasana</h2>

              <p className="about-role">
                Researcher at the Institute for Applied Mathematics and
                Information Technologies “Enrico Magenes” of the National
                Research Council of Italy (CNR-IMATI).
              </p>
            </div>

            <img
              src="/images/simone.png"
              alt="Simone Cammarasana"
              className="about-photo"
            />
          </div>

          <p>
            My research focuses on applied mathematics, scientific computing, image processing,
            number theory, optimization models, biomedical data, and artificial intelligence.
          </p>

          <p>
            My publications are available on{" "}
            <a
              href="https://scholar.google.com/scholar?hl=it&as_sdt=0%2C5&q=simone+cammarasana&btnG=&oq=simone"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Scholar
            </a>
            .
          </p>

          <p className="about-note">
            Rapid First Look is a personal initiative. It is not an official
            service of CNR or CNR-IMATI.
          </p>
        </div>
      </div>
    </section>
  )
}